import Filter from '@scripts/modules/Filter.js';

class GalleryFilter extends Filter {

  constructor() {
    super();
    this.form = document.getElementById("gallery-filter-form");
    this.init()
  }

  static existsOnPage() {
    return (document.getElementById("gallery-filter-form") !== null);
  }

  init() {
    this.form.addEventListener('submit', (e) => {
      // e.preventDefault()
      this.prepareForm()
      // debugger
    })
  }

  /** 
   * Подготовка полей формы к отправке.
   */
  prepareForm() {
    const fieldNames = ['place', 'feat']
    super.prepareForm(fieldNames);
  }
}

export default GalleryFilter;

